const HIDDEN_DAM_DEPLOYMENT_MODES = new Set(['media_library', 'scai_dam']);

/** SitecoreAI / FGA-primary DAM deployment mode. */
export const SCAI_DAM_DEPLOYMENT_MODE = 'scai_dam';

/** Portal product code for SitecoreAI DAM icons and appearance. */
export const SCAI_DAM_PRODUCT_CODE = 'SCAI_DAM';

export type TenantLabel = { key: string; value: string };

export const isHiddenDamTenant = (labels?: TenantLabel[] | null) =>
  labels?.some(
    (l) =>
      l.key === 'DeploymentMode' && HIDDEN_DAM_DEPLOYMENT_MODES.has(l.value),
  ) ?? false;

export const isDamProduct = (productCode?: string | null) =>
  productCode?.toLowerCase() === 'dam';

const hasDeploymentMode = (
  labels: TenantLabel[] | null | undefined,
  mode: string,
) =>
  labels?.some((l) => l.key === 'DeploymentMode' && l.value === mode) ?? false;

/** FGA-primary DAM: product code DAM deployed as SitecoreAI DAM. */
export const isFgaPrimaryDam = (
  productCode?: string | null,
  labels?: TenantLabel[] | null,
) =>
  isDamProduct(productCode) &&
  hasDeploymentMode(labels, SCAI_DAM_DEPLOYMENT_MODE);

/**
 * SCAI_DAM only hides FGA-primary DAM (product code DAM and DeploymentMode scai_dam).
 * media_library and every other mode stay in the list whether the flag is on or off.
 */
export const isTenantVisibleForScaiDamFlag = (
  productCode: string | null | undefined,
  labels: TenantLabel[] | null | undefined,
  isScaiDamEnabled: boolean,
) => isScaiDamEnabled || !isFgaPrimaryDam(productCode, labels);

/**
 * Portal product code used for icons.
 * Inventory still identifies SitecoreAI DAM as product code DAM with
 * DeploymentMode scai_dam. Content Service assigns SCAI_DAM.
 * Every other product code is returned unchanged, including media_library DAM.
 */
export const getPortalProductCode = (
  productCode?: string | null,
  labels?: TenantLabel[] | null,
) =>
  isFgaPrimaryDam(productCode, labels) ? SCAI_DAM_PRODUCT_CODE : productCode;
